module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Yvorne_(Vaud)-004abd8c5fb66e25a86f9db10cbc598b.svg";